import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { useMangoApi } from '~/atoms/MangoApi'

import { CallsReport, CallsReportRequest } from '@mangovoice/types'
import { ApiError } from '@mangovoice/types'

interface UseGetCallsReportParams {
  reportRequest: CallsReportRequest
  onQuerySuccess?: (data: CallsReport) => void
  options?: Omit<UseQueryOptions<CallsReport, ApiError>, 'queryKey' | 'queryFn'>
}

export const useGetCallsReport = ({
  reportRequest,
  onQuerySuccess,
  options = {},
}: UseGetCallsReportParams) => {
  const mangoApi = useMangoApi()

  const query = useQuery<CallsReport, ApiError>({
    queryKey: ['callsReport', reportRequest],
    queryFn: async () => {
      const { ok, data } = await mangoApi.getCallsReport(reportRequest)

      if (!ok) return Promise.reject(data as ApiError)
      if (!data)
        return Promise.reject(new Error('No data returned from report'))

      onQuerySuccess?.(data)
      return data
    },
    ...options,
    retry: (options.retry as number | boolean | undefined) ?? false,
  })

  return query
}
